import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { Route, Router } from '@angular/router';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login-boxed',
  templateUrl: './login-boxed.component.html',
  styles: []
})
export class LoginBoxedComponent implements OnInit {
username:any;
password:any;

  constructor(private toastr:ToastrService,
              private spinner:NgxSpinnerService,
              private router:Router,
              private loginService:LoginService,
            ) { }

  ngOnInit() {
  }

  login(){
    if(this.username || this.password){
      let sendData = {
        userName: this.username,
        password : this.password
      }
      this.spinner.show()
      this.loginService.login(sendData).subscribe((result:any)=>{
        console.log('login response   ',result);
        if(result.statusCode == 200){
          this.spinner.hide()
          this.toastr.success(result.message);
          this.router.navigate(['dashboard']);
          sessionStorage.setItem('token' , result.token)
          sessionStorage.setItem('adminInformation' , JSON.stringify(result.userData) )
        }else{
          this.spinner.hide()
          this.toastr.error(result.message);
        }
      })
      
    }else{
      this.toastr.warning('Please enter username or passowrd')
    }
  }




  register(){
    this.router.navigateByUrl('pages/register-boxed');
  }
}
